import { forwardRef } from 'react';
import * as ContextMenu from '@radix-ui/react-context-menu';
import { darken, lighten, rgba } from 'polished';
import styled from 'styled-components';

import { LinkWithQuery } from '@/components/global/LinkWithQuery';
import { ReactComponent as IconArrowRight } from '@/images/icons/icon-arrow-right.svg';
import { MEDIA_KIT_LINK } from '@/utils';

const Content = styled(ContextMenu.Content)`
  border-radius: calc(5rem / 16);
  padding: calc(4rem / 16);
  background-image: ${({ theme }) => {
    const stop1 = theme.palette.fg100;
    const stop2 = darken(0.03125, theme.palette.fg100);
    return `radial-gradient(at 0% 0%, ${rgba(stop1, 0.98)} 58%, ${rgba(stop2, 0.98)})`;
  }};
  box-shadow: ${({ theme }) => {
    const lowlight = `0px 0.5px 0 0.75px ${lighten(0.125, theme.palette.fg100)}`;
    const primary = '4px 16px 32px -12px hsla(0 0% 0% / 0.72)';
    return [lowlight, primary].join(',');
  }};
  z-index: 4;
`;

const FgLoud = styled.span`
  color: ${({ theme }) => theme.palette.fgLoud};
`;

const Link = styled(LinkWithQuery)`
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: none;
  transition: background-color 0.2s ease;
  padding: 0.6rem 0.85rem 0.6rem 0.75rem;
  border-radius: calc(1rem / 16);
  font-size: ${({ theme }) => theme.fontSize.body.base};
  line-height: ${({ theme }) => theme.lineHeight.body.base};
  white-space: nowrap;

  svg {
    color: ${({ theme }) => theme.palette.fg1200};
  }

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.palette.fg500};
  }
`;

export const MediaContextMenu = forwardRef<HTMLDivElement>(
  function MediaContextMenu(_, ref) {
    return (
      <Content ref={ref}>
        <ContextMenu.Item>
          <Link isExternal={true} to={MEDIA_KIT_LINK}>
            <FgLoud>View media kit</FgLoud> <IconArrowRight />
          </Link>
        </ContextMenu.Item>
      </Content>
    );
  }
);
